import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row flex-column-fluid" }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1" }
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-lg-row-fluid" }
const _hoisted_4 = { class: "<?php echo $params['wrapperClass']?> p-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-wrap px-5" }, null, -1)
const _hoisted_6 = {
  class: "d-flex flex-lg-row-fluid w-lg-25 bgi-size-cover bgi-position-center order-1 order-lg-2",
  style: {"background-image":"url('/images/bg/auth-screens.png')"}
}
const _hoisted_7 = { class: "d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/images/logos/logo.svg",
  class: "h-60px h-lg-75px"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20",
  src: "/images/bg/auth-screens.png",
  alt: ""
}, null, -1)

import { onMounted, onUnmounted } from "vue";
import { useStore } from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  setup(__props) {

const store = useStore();
const router = useRouter();

onMounted(() => {
  if (store.getters.isUserAuthenticated) {
    // console.log("isUser2fa", store.getters.isUser2fa);
    if (!store.getters.isUser2fa) {
      router.push({ name: "2fa" });
    } else {
      router.push({ name: "dashboard" });
    }
  }
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
});

onUnmounted(() => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ])
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "mb-0 mb-lg-12"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _hoisted_9
      ])
    ])
  ]))
}
}

})